<template>
<div 
    class="w-full relative mt-5 flex border-2 border-transparent rounded-md pass-form"
>
    <div class="inline-flex items-center text-xs pl-3 pr-1 pt-1 text-center rounded-l-md bg-light-blue" type="button">
        +7
    </div>
    <div class="relative w-full">
        <input
            v-maska="boundObject"
            v-model="phoneNumber"
            @input="updatePhone"
            data-maska="(###)-###-##-##"
            placeholder="(999)-999-99-99"
            class="block h-10 w-full text-xs bg-light-blue outline-none rounded-r-md pt-1" 
        />
    </div>
    <label class="absolute top-1 left-3 transparent small-text-label select-none">Номер телефона</label>
    <div class="absolute right-3 top-3">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 fill-gray-500">
            <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" />
        </svg>
    </div>
</div>
</template>
<script>
    import { vMaska } from "maska"
    import { useStore } from 'vuex'
    export default {
        name: "LoginInputPhone",
        directives: { maska: vMaska },
        data() {
            return {
                phoneNumber: "",
                boundObject: {
                    masked: "",
                    unmasked: "",
                    completed: false
                }
            }
        },
        setup() {
            const store = useStore();

            return {
                store
            }
        },
        methods: {
            updatePhone: function() {
                this.store.commit('updatePhoneNumber', this.boundObject.unmasked)
            }
        }
    }
</script>

<style scoped>
    .bg-light-blue {
        background-color: #dee8f5;
    }
    .small-text-label {
        font-size: 0.5rem
    }
    .pass-form:focus-within {
        border: 2px solid rgb(37 99 235);
    }
</style>

